import type { ILinkButtonProps } from "@molecules/linkButton";

export enum INotifCardSizeEnum {
  X_Small = "x-small",
  Small = "small",
  Large = "large",
}

export enum INotifCardVariantsEnum {
  Error = "error",
  Warning = "warning",
  Success = "success",
  Information = "information",
  Feature = "feature",
  Promise = "promise",
}

export enum INotifCardStyleEnum {
  Filled = "filled",
  Light = "light",
  Lighter = "lighter",
  Stroke = "stroke",
}

export interface INotifCardProps {
  title: string;
  action?: Omit<ILinkButtonProps, "ref">;
  description?: string;
  size?: INotifCardSizeEnum;
  variant?: INotifCardVariantsEnum;
  styleType?: INotifCardStyleEnum;
  noClose?: boolean;
  className?: string;
}

export type INotifyProps = Omit<INotifCardProps, "variant"> & {
  toastId?: string;
};
export type IPromiseProps<T> = Omit<INotifyProps, "title" | "description"> & {
  title: string | ((data: T | undefined) => string);
  description?: string | ((data: T | undefined) => string);
};
export interface INotifyPromiseProps<TData, TError> {
  success: IPromiseProps<TData>;
  error: IPromiseProps<TError>;
  pending: INotifyProps;
  promise: Promise<TData> | (() => Promise<TData>);
}
